import React, { Suspense, lazy, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { SettingsProvider } from "@/context/SettingsContext";
import { CartProvider } from "@/context/CartContext";
import { track } from "@/lib/api";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import CartDrawer from "@/components/CartDrawer";

import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderConfirmation from "@/pages/OrderConfirmation";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import PolicyPage from "@/pages/PolicyPage";

const AdminApp = lazy(() => import("@/admin/AdminApp"));

function Analytics() {
  const loc = useLocation();
  useEffect(() => {
    track("page_view", { path: loc.pathname });
    const params = new URLSearchParams(loc.search);
    if (params.get("source")) track("qr_visit", { source: params.get("source") });
  }, [loc.pathname]);
  return null;
}

function ScrollTop() {
  const loc = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [loc.pathname]);
  return null;
}

function Storefront() {
  return (
    <>
      <Header />
      <CartDrawer />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product/:slug" element={<ProductPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/order/:orderNumber" element={<OrderConfirmation />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/policy/:type" element={<PolicyPage />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SettingsProvider>
          <CartProvider>
            <Analytics />
            <ScrollTop />
            <Toaster position="top-center" richColors />
            <Routes>
              <Route
                path="/admin/*"
                element={
                  <Suspense fallback={<div className="min-h-screen flex items-center justify-center text-forest">Loading admin…</div>}>
                    <AdminApp />
                  </Suspense>
                }
              />
              <Route path="/*" element={<Storefront />} />
            </Routes>
          </CartProvider>
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
